export const API_KEY = process.env.NEXT_PUBLIC_HONEYBADGER_API_KEY;
